import React, { useState } from 'react';
import { usePIM } from '../context/PIMContext';
import { Info } from 'lucide-react';
import { BASE_UPLOAD_URL } from '../config';

const PackageContentsPanel = () => {
    const { components, activeCharge } = usePIM();

    // Filter components that are accessories AND marked as package content
    const packageContents = components
        .filter(c => c.role === 'accessory' && c.is_package_content);

    return (
        <div className="flex flex-col h-full" style={{ height: '100%' }}>
            <h3 className="text-stone-300 font-semibold text-lg mb-3 flex items-center justify-between shrink-0">
                <span>Package contents ({activeCharge ? activeCharge.batch_number : 'No Charge'})</span>
            </h3>

            <div className="flex-1 overflow-y-auto pr-2 min-h-0 [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-stone-700/50 [&::-webkit-scrollbar-thumb]:rounded-full hover:[&::-webkit-scrollbar-thumb]:bg-stone-600">
                {packageContents.length === 0 ? (
                    <div className="text-stone-600 text-center py-10 italic">
                        No package contents defined.
                    </div>
                ) : (
                    <div className="grid grid-cols-3 gap-2 h-full" style={{ gridAutoRows: 'calc((100% - 16px) / 3)' }}>
                        {packageContents.map((item) => (
                            <a
                                key={item.id}
                                href={`/?sku=${item.sku}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-transparent rounded-xl p-2 flex flex-col items-center justify-center border border-white/10 hover:border-blue-400/40 hover:bg-white/5 hover:shadow-[0_0_15px_rgba(59,130,246,0.2)] transition-all duration-300 relative cursor-pointer h-full backdrop-blur-sm group/card hover:z-50"
                            >
                                {item.image_url ? (
                                    <div className="flex-1 w-full relative min-h-0 mb-1.5 mt-1 flex items-center justify-center">
                                        <img src={`${BASE_UPLOAD_URL}/${item.image_url.replace(/^\/+/, '')}`} alt={item.model_name} className="absolute inset-0 w-full h-full object-contain px-2 pt-1 pb-1" />
                                    </div>
                                ) : (
                                    <div className="flex-1 w-full mt-2 rounded-lg bg-white/5 border border-white/5 flex items-center justify-center text-[10px] text-stone-500 mb-1.5 text-center leading-tight">
                                        No Img
                                    </div>
                                )}
                                <span className="text-stone-300 font-medium text-[11px] text-center leading-tight line-clamp-2 w-full px-1 shrink-0 pb-1">
                                    {item.model_name}
                                </span>

                                {/* Info Icon */}
                                <div className="absolute top-1 right-1 text-stone-500 hover:text-stone-300 group/info cursor-help">
                                    <Info size={12} />
                                    
                                    {/* Tooltip visible on hover */}
                                    <div className="absolute top-full right-0 mt-1 w-48 bg-black/80 backdrop-blur-md border border-white/10 rounded-lg p-3 shadow-[0_0_15px_rgba(0,0,0,0.5)] hidden group-hover/info:block z-50 pointer-events-none">
                                        <div className="text-xs space-y-1.5 text-left">
                                            <div className="font-bold text-white border-b border-white/10 pb-1.5 mb-1.5 truncate">{item.model_name}</div>
                                            <div className="flex justify-between"><span className="text-stone-400">SKU:</span> <span className="text-stone-200 truncate ml-2 font-mono">{item.sku}</span></div>
                                            <div className="flex justify-between"><span className="text-stone-400">EAN:</span> <span className="text-stone-200">{item.ean || '-'}</span></div>
                                            <div className="flex justify-between"><span className="text-stone-400">Color:</span> <span className="text-stone-200">{item.color || '-'}</span></div>
                                            <div className="flex justify-between"><span className="text-stone-400">Stock:</span> <span className="text-stone-200">{item.stock || 0}</span></div>
                                            <div className="flex justify-between"><span className="text-stone-400">Status:</span> <span className="text-stone-200">{item.status || '-'}</span></div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PackageContentsPanel;
